import { authPost } from "@api";

import {
  SCMConfig,
  SCMConfigRequest,
  SCMConfigUserInput,
} from "@pages/settings/types";

export const createSCMConfig = (
  newSCM: SCMConfigUserInput,
  parentOrgId: number
): Promise<{ scm_config: SCMConfig }> => {
  const path = `/api/agent/organizations/${parentOrgId}/scm_configs`;
  return authPost<SCMConfigRequest, { scm_config: SCMConfig }>(path, {
    scm_config: newSCM,
  });
};
